import { useQuery } from "@tanstack/react-query";
import { fetchCustomPropertyNote } from "@/lib/api";

export const extractNote = (res) => {
    if (typeof res === "string") return res.trim();
    if (!res || typeof res !== "object") return "";
    if (typeof res.note === "string") return res.note.trim();
    if (typeof res.data === "string") return res.data.trim();
    if (typeof res.data?.note === "string") return res.data.note.trim();
    return "";
};

export const propertyNoteKey = (propertyId) => ["propertyNote", String(propertyId)];

export const usePropertyNoteText = (propertyId, enabled = true) =>
    useQuery({
        queryKey: propertyNoteKey(propertyId),
        queryFn: async () => extractNote(await fetchCustomPropertyNote(propertyId)),
        enabled: Boolean(enabled && propertyId),
        staleTime: 5 * 60 * 1000,
        retry: 1,
    });